import gymImg from "../../images/who-we-are/gym.png";
import WorkoutImg from "../../images/who-we-are/workout.png";
import trainerssvg from "../../images/who-we-are/trainers.svg";

export const cardList = [
  {
    img: gymImg,
    title: "Outdoor Services",
    description:
      "Enjoy dynamic outdoor workouts that boost endurance and well-being.Our team of experts will work with you to create a customized plan that helps you achieve success one step at a time.",
  },
  {
    img: WorkoutImg,
    title: "Strength",
    description:
      " Engage in targeted strength training with personalized workouts.Variety of workouts to choose from, you'll have everything you need to get into the best shape of your life.",
  },
  {
    img: trainerssvg,
    title: "Mentors",
    description:
      "Get expert guidance with tailored workout plans. Our trainers focus on your goals, correct your form, and keep you motivated to achieve the best results.",
  },
];